import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=614a3afb&scoped=true"
import script from "./Department.js?vue&type=script&lang=js&external"
export * from "./Department.js?vue&type=script&lang=js&external"
import style0 from "./Department.scss?vue&type=style&index=0&id=614a3afb&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614a3afb",
  null
  
)

export default component.exports